import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from './contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AutoLoginPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/magic-login`, { token }, { withCredentials: true });
        if (cancelled) return;
        setStatus('success');
        if (checkAuth) {
          try { await checkAuth(); } catch { /* ignore */ }
        }
        const role = r.data?.role;
        const target = role === 'client' ? '/client' : '/dashboard';
        setTimeout(() => navigate(target, { replace: true }), 1200);
      } catch (e) {
        if (cancelled) return;
        setStatus('error');
        setError(e.response?.data?.detail || 'Lien invalide ou expire');
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#003E40] to-[#008A8D] flex items-center justify-center px-4" data-testid="auto-login-page">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        {status === 'loading' && (
          <>
            <div className="w-14 h-14 border-4 border-t-[#008A8D] border-gray-200 rounded-full animate-spin mx-auto mb-5" />
            <h1 className="text-xl font-bold text-[#003E40] mb-2">Connexion en cours...</h1>
            <p className="text-gray-500 text-sm">Verification de votre lien d'acces.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-5">
              <svg className="w-9 h-9 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
            </div>
            <h1 className="text-xl font-bold text-[#003E40] mb-2">Connecte !</h1>
            <p className="text-gray-500 text-sm">Redirection vers votre espace...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5">
              <svg className="w-9 h-9 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            </div>
            <h1 className="text-xl font-bold text-[#003E40] mb-2">Lien invalide</h1>
            <p className="text-gray-600 text-sm mb-1">{error}</p>
            <p className="text-gray-400 text-xs mb-5">Les liens d'acces ne sont valables qu'une seule fois et expirent au bout de 14 jours.</p>
            <button
              onClick={() => navigate('/login')}
              className="px-5 py-2 bg-[#008A8D] hover:bg-[#003E40] text-white rounded-lg font-semibold"
              data-testid="autologin-fallback-btn"
            >
              Aller a la page de connexion
            </button>
            <p className="text-xs text-gray-400 mt-4">Vous pouvez aussi utiliser les identifiants email + mot de passe contenus dans votre email.</p>
          </>
        )}
      </div>
    </div>
  );
}
